import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader";
import useProgressPreview from "./hooks/useProgressPreview";
import ProgressLine from "./ProgressLine";

const ProgressPreview = () => {
  const { t } = useTranslation();
  const { progress, isLoading } = useProgressPreview();

  if (isLoading) {
    return (
      <div style={{ margin: "auto" }}>
        <Loader small />
      </div>
    );
  }

  return (
    <div>
      <h2>{t("nav.progress")}</h2>
      <br />
      {progress?.map((progressLine) => (
        <ProgressLine key={progressLine?.topic?.id} {...progressLine} />
      ))}
    </div>
  );
};

export default ProgressPreview;
